import { React, useState, useEffect, useContext } from "react";
import "./SecondVendor.css";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import Veggies_Section_Card from "../../Common-Component/Veggies_Section_Card/Veggies_Section_Card";
import Product_Card from "../../Common-Component/Product_Card/Product_Card";
import { Context } from "../../../utils/context";

import { Products } from "../../../utils/apis/Product/Product";
import { useNavigate, useOutlet } from "react-router-dom";

import SupermarketModal from "../../Common_modal/Supermarket-modal/SupermarketModal";

const SecondVendor = ({ heading, product }) => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [activeHearts, setActiveHearts] = useState([]);
  const handleMainSliderClick = (direction) => {
    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  const { IMG_URL } = useContext(Context);

  const [addCartModal, setAddCartModal] = useState(false);
  const [products, setProduct] = useState([]);
  const getProducts = async () => {
    const res = await Products(product?.category_id, "", "");
    if (res?.success) {
      setProduct(res?.data?.data);
    }
  };

  useEffect(() => {
    getProducts();
  }, [product]);

  const navigate = useNavigate();
  const handleProductClick = (product_id) => {
    localStorage.setItem("product_id", product_id);

    // window.scrollTo({ top: 0, behavior: "smooth" });

    navigate(`/vendor-page/${product_id}`);

    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  return (
    <>
      <section className="Frequently-Bought">
        <Container fluid>
          <h1 className="title">{heading}</h1>
          <Swiper
            breakpoints={{
              0: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              420: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              486: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              576: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              992: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
            }}
            navigation={true}
            modules={[Navigation, Pagination, Autoplay]}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            loop
            className="mySwiper pb-3"
            onSwiper={(swiper) => setSwiperInstance(swiper)}>
            {products?.map((product, index) => (
              <SwiperSlide key={index}>
                <div

                  style={{ cursor: "pointer" }}>
                  <Product_Card
                    image={IMG_URL + product?.image1}
                    product_id={product?.id}
                    text={product?.name}
                    newest={product?.newest}
                    subText={product?.short_description}
                    // price={
                    //   product?.variants[0]?.mrp
                    //     ? product?.variants[0]?.mrp
                    //     : product?.m_variants[0]?.mrp
                    // }
                    price={
                      product?.product_multiple_mains?.[0]
                        ?.product_multiple_variants?.[0]?.mrp
                        ? product?.product_multiple_mains?.[0]
                          ?.product_multiple_variants?.[0]?.mrp
                        : product?.product_variants?.[0]?.mrp
                    }
                    cutprice={
                      product?.product_multiple_mains?.[0]
                        ?.product_multiple_variants?.[0]?.cutting_price
                        ? product?.product_multiple_mains?.[0]
                          ?.product_multiple_variants?.[0]?.cutting_price
                        : product?.product_variants?.[0]?.cutting_price
                    }
                    variant_id={product?.product_variants?.id}
                    m_variant_id={
                      product?.product_multiple_mains?.product_multiple_variants
                        ?.id
                    }
                    handleProductClick={handleProductClick}
                  // onClick={() => handleProductClick(product?.id)}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <SupermarketModal
            show={addCartModal}
            onHide={() => setAddCartModal(false)}
          />
          <div class="silder-btn">
            <div
              className="back-btn"
              onClick={() => handleMainSliderClick("prev")}></div>
            <div
              className="next-btn"
              onClick={() => handleMainSliderClick("next")}></div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default SecondVendor;
